<template>
  <section class="mb-0">
    <div class="bg-size-cover bg-position-center rounded-0 px-md-5 text-center pt-3 pt-sm-3 hero-bg">
      <div class="align-items-center px-0 px-sm-5 mx-auto pb-sm-3 pt-3">
        <div class="mb-5 mx-0 mx-sm-3" id="evaluationCard">
          <evalComplete v-if="evalManager.evalComplete === true"/>
          <details-dialog v-else/>
        </div>
      </div>
    </div>
  </section> 
</template>


<script>
import { mapGetters } from 'vuex';
import detailsDialog from "./detailsDialog.vue"
import evalComplete from "./evalComplete.vue"

export default {
  name: 'EvalHero',
  components: {
    detailsDialog,
    evalComplete
  },
  data: function () { 
    return {
    };
  },
  computed: {
    ...mapGetters(['evalManager', 'evalManagerError']),
  },
  created: function () {
    this.setupDialog();
  },
  mounted: function () {
  },
  methods: {
    setupDialog: async function () {
      if(this.evalManager.evalComplete === null) {
        this.$router.push({path: "/"});
      }
    }
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .hero-bg1 {
    background: linear-gradient(to bottom, rgba(50,50,50,0.5), rgba(50,50,50,0.5)), url("/img/dining2.jpg"); 
    background-position: center; 
    background-repeat: no-repeat; 
    background-size: cover; 
  }
}
</style>